import {useState} from 'react';
import stories from './stories/stories';
import './WorldMap.css';
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import BossIconComponent from "./BossIcon/BossIconComponent";
import {useActions} from "../../../hooks/useActions";
import {isMobile} from "react-device-detect";


function WorldMap() {

    const [bossWindowVisible, setBossWindowVisible] = useState(false);

    const {tutorial, user} = useTypedSelector(state => state.auth);

    if (!bossWindowVisible && (tutorial.step === 'BossWindow30' || tutorial.step === 'MenuResearch90') && isMobile) { // hack for tutorial on  Iphone

        setBossWindowVisible(true);
    }

    const {setSystemMessage, setRoute, setTutorial} = useActions();

    return (
        <div className="world_map_bg">

            <BossIconComponent
                key={'promo'}
                story={stories.PromoStory}
                               className={stories.PromoStory.classCss}
                               isPromo={true}
            />


            {Object.entries(stories)
                .filter(([key]) => key !== 'PromoStory')
                .map(([key, StoryComponent]) => (
                    <BossIconComponent
                        key={key}
                        story={StoryComponent}
                        className={StoryComponent.classCss}
                    />
                ))}


            {(user.level < 4) ?
                <div className="mapArenaIcon mapArenaIconGrey" onClick={() => {
                    setSystemMessage({isVisible: true, type: 'info', text: "Required chapter 2", action: null});
                }}></div>
                :
                <div className="mapArenaIcon defaultButtonAnimation_6" onClick={() => {
                    if(tutorial.isActive && tutorial.step === 'ArenaStart200'){
                        tutorial.step = 'ArenaDaily210';
                        setTutorial(tutorial);
                    }
                    setRoute('arena');
                }}></div>
            }


        </div>
    );
}

export default WorldMap;
